import React from 'react';

// Payment details, shown on the order form and again once the order total
// has been calculated. Deliberately large — customers should not have to
// hunt for how to pay.
const PaymentInfo = () => (
  <div className="payment-info">
    <p className="payment-info-heading">All payments can be made to:</p>
    <ul className="payment-info-list">
      <li><span className="payment-method">Venmo</span> @Bryann-isaacs</li>
      <li><span className="payment-method">Quickpay</span> ranzey@aol.com</li>
      <li><span className="payment-method">Zelle</span> Bryann Isaacs</li>
    </ul>
  </div>
);

export default PaymentInfo;
